<div class="card assessment-card">
    <div class="card-body">
        <div class="heading-section">
            @if (getPanelConfig()?.heading) {
                <h3 class="card-title">{{ getPanelConfig()?.heading }}</h3>
            }
            @if (getPanelConfig()?.subHeading) {
                <p class="card-text text-muted">{{ getPanelConfig()?.subHeading }}</p>
            }
        </div>
        @if (getPanelConfig()?.links) {
            <div class="d-flex">
                <div class="btn-wrapper">
                    @for (link of getPanelConfig()?.links; track link.text) {
                        <a class="btn" [ngClass]="link.text == 'Recommended' ? 'gradient-text': ''" [routerLink]="link.route" routerLinkActive="active-button"
                            [routerLinkActiveOptions]="{exact: true}" [title]="link.text">
                            @if (link.icon) {
                                <i class="{{ link.icon }}" [ngClass]="link.text == 'Recommended' ? 'gradient-icon': ''"></i>
                            }
                            {{ link.text }}
                        </a>
                    }
                </div>
            </div>
        }
    </div>
</div>